<label [attr.for]="for" class="label">
  <ng-content></ng-content>
</label>